import Vue from 'vue'
import Vuex from 'vuex'
import '../firebaseConfig'
import router from '../router'
import firebase from "firebase/app";
import "firebase/database"
import "firebase/auth";
import { status } from "./status";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: () => {
    return {
      current_user: null,
    }
  },
  mutations: {
    
    SET_CURRENT_USER(state,user) { state.current_user = user },
    
  },
  getters: {
    current_user(state) { return state.current_user },
  },
  actions: {
    storeCurrentUser({commit},user) { commit('SET_CURRENT_USER',user) },
    
    mergeData({commit},payload) { // eslint-disable-line
      console.log("Payload:",payload)
      var newMergeRef = firebase.database().ref('/merges/').push()
      newMergeRef.set({ from: payload.from, to: payload.to }).then(() => console.log("Saved merge for later") )

    },

    updateRegistration({dispatch,state},registration) {
      var registration_key = registration.number_plate.toUpperCase() 
      var hasDetails = Object.keys(registration.details).length > 0
      var defaultErrorMessage = {text: "No information provided", type:'is-danger'}
      var defaultCompletedMessage = {text:"Number plate registration "+ registration_key + " has been sucessfully nominated",type:'is-success'}

      if( hasDetails && state.current_user ) {
        console.log("Update Registration")
        var registrationRef = firebase.database().ref('/numberplates/'+registration_key+'/reports/'+state.current_user.uid)
        if(registration.on_error) { defaultErrorMessage = registration.on_error }
        if(registration.on_success) { defaultErrorMessage = registration.on_success }

        registrationRef.update(registration.details).then(()=>{        
          dispatch('loading',false)
          if(registration.next_path) {
            router.push(registration.next_path)
          } else { 
            dispatch('setMessage', defaultCompletedMessage)
            router.push('/')
          }
        }).catch((error=>{
          console.error(error)
          dispatch('setMessage', defaultErrorMessage)
          dispatch('loading',false)  
        }))
      } else {
        dispatch('setMessage', defaultErrorMessage)
        dispatch('loading',false)
      }
    },
  },
  modules: {
    status: status,
  },
})

// firebase.auth().onAuthStateChanged doesn't capture when we login using a new linked account
firebase.auth().onIdTokenChanged(function(user) {
  console.log("ID token Change: ",user && user.uid,user)
  if(!user) {
    console.debug("Signing in Anonymously")
    firebase.auth().signInAnonymously().then((result)=> {
      console.debug("Signed in Anonymously", result.user)
      store.dispatch("storeCurrentUser",result.user)
    }).catch((error) => {
      console.error("Error on Login",error.code, error.message)
    });
  } 
  store.dispatch("storeCurrentUser",user)
});

var connectedRef = firebase.database().ref(".info/connected");
connectedRef.on("value", snap => {
  console.log("CHANGE OF FB CONNECTION STATE", snap.val())
  var beenConnected = store.state.status.firebase.beenConnected
  if(snap.val()) { // This is a connection
    if(beenConnected) {
      console.debug("Reconnected to firebase")
      store.dispatch('setMessage', {text: "Reconnected to firebase",type: 'is-success'})
    } else { store.dispatch('setMessage', {text: "Connection Successful",type: 'is-info'}) }
    store.commit("CONNECT_FIREBASE")
  } else { // This is a disconnection
    if(beenConnected) {
      console.debug("Disconnected from firebase")
      store.dispatch('setMessage', {text: "Disconnected from Service... Will attempt to reconnect",type: 'is-danger'})
      store.commit("DISCONNECT_FIREBASE")
    } else { store.dispatch('setMessage', {text: "Connecting to the service",type: 'is-info'}) }
  }  
});

export default store